import { useMutation } from '@tanstack/react-query'
import { InvoiceFormValues } from 'app/components/InvoiceForm/schema'
import transformValuesToApi from 'app/components/InvoiceCreate/translators/transformFormValuesToAPI'
import { Invoice } from 'types/index'
import { useApi } from 'api'

const useCreateInvoice = ({
  onSuccess,
  onError,
}: {
  onSuccess: (invoice: Invoice) => void
  onError?: (error: Error) => void
}) => {
  const client = useApi()

  const { mutate: createInvoice, isPending } = useMutation({
    mutationFn: async (data: InvoiceFormValues) => {
      const response = await client.postInvoices(
        null,
        transformValuesToApi(data)
      )
      return response.data
    },
    onSuccess,
    onError,
  })

  return { createInvoice, isPending }
}

export default useCreateInvoice
